export default function expandMapping(mapping: Record<string, string>): Record<string, unknown> {
    return Object.entries(mapping).reduce<Record<string, unknown>>((expandedMapping, [key, value]) => {
        const nestedKeys = key.split(".")
        let currentLevel = expandedMapping

        for (let i = 0; i < nestedKeys.length - 1; i++) {
            const nestedKey = nestedKeys[i]!
            if (!currentLevel[nestedKey]) {
                currentLevel[nestedKey] = {}
            }
            // @ts-expect-error type mismatch
            currentLevel = currentLevel[nestedKey]
        }

        const lastKey = nestedKeys[nestedKeys.length - 1]!
        currentLevel[lastKey] = value

        return expandedMapping
    }, {})
}
